module.exports = __webpack_public_path__ + "static/media/DM130L_ BETTER.6566ead2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/options/DM130L_ BETTER.jpg
// module id = 214
// module chunks = 0